import { create } from 'zustand';

type BizySidePanelView = 'chat' | 'history';

export const BIZY_PANEL_DEFAULT_WIDTH = 352;
export const BIZY_PANEL_MIN_WIDTH = 280;
export const BIZY_PANEL_MAX_WIDTH = 560;

interface BizySidePanelStore {
	isOpen: boolean;
	hasAutoOpened: boolean;
	view: BizySidePanelView;
	width: number;
	isResizing: boolean;
	open: () => void;
	close: () => void;
	toggle: () => void;
	showChat: () => void;
	showHistory: () => void;
	setDefaultOpen: (isOpen: boolean) => void;
	setWidth: (width: number) => void;
	setIsResizing: (isResizing: boolean) => void;
}

export const useBizySidePanelStore = create<BizySidePanelStore>((set, get) => ({
	isOpen: false,
	hasAutoOpened: false,
	view: 'chat',
	width: BIZY_PANEL_DEFAULT_WIDTH,
	isResizing: false,
	open: () => set({ isOpen: true }),
	close: () => set({ isOpen: false }),
	toggle: () => set((state) => ({ isOpen: !state.isOpen })),
	showChat: () => set({ view: 'chat' }),
	showHistory: () => set({ view: 'history' }),
	setDefaultOpen: (isOpen) => {
		if (get().hasAutoOpened) return;
		if (isOpen) set({ isOpen, hasAutoOpened: true });
	},
	setWidth: (width) => set({ width: Math.max(BIZY_PANEL_MIN_WIDTH, Math.min(BIZY_PANEL_MAX_WIDTH, width)) }),
	setIsResizing: (isResizing) => set({ isResizing }),
}));
